export const STORE_HUB_PATH = '/management/stores';

export const STORE_HUB_TABS = {
  MAIN: 'main',
  IMAGES: 'images',
  ROLES: 'roles',
  ON_REQUEST_HOURS: 'on-request-hours',
  ADDITIONAL_COSTS: 'additional-costs',
  WAITLIST: 'waitlist',
  BRANDING: 'branding',
};

export const getStoreHubPath = (tab) => {
  if (!tab || tab === STORE_HUB_TABS.MAIN) {
    return STORE_HUB_PATH;
  }
  return `${STORE_HUB_PATH}?tab=${encodeURIComponent(tab)}`;
};

export const getStoreWaitlistPath = (storeId) => (
  storeId ? `/management/stores/${storeId}/waitlist` : getStoreHubPath(STORE_HUB_TABS.WAITLIST)
);

export const resolveStoreHubTab = (tabParam, {
  canViewImages,
  canViewRoles,
  canUpdate,
  canViewWaitlist,
  canViewBranding,
  allowsRoles = true,
  allowsWaitlist = true,
  allowsAdditionalHours = true,
} = {}) => {
  if (tabParam === STORE_HUB_TABS.IMAGES && canViewImages) {
    return STORE_HUB_TABS.IMAGES;
  }
  if (tabParam === STORE_HUB_TABS.ROLES && canViewRoles && allowsRoles) {
    return STORE_HUB_TABS.ROLES;
  }
  if (tabParam === STORE_HUB_TABS.ON_REQUEST_HOURS && canUpdate && allowsAdditionalHours) {
    return STORE_HUB_TABS.ON_REQUEST_HOURS;
  }
  if (tabParam === STORE_HUB_TABS.ADDITIONAL_COSTS && canUpdate && allowsAdditionalHours) {
    return STORE_HUB_TABS.ADDITIONAL_COSTS;
  }
  if (tabParam === STORE_HUB_TABS.WAITLIST && canViewWaitlist && allowsWaitlist) {
    return STORE_HUB_TABS.WAITLIST;
  }
  if (tabParam === STORE_HUB_TABS.BRANDING && canViewBranding) {
    return STORE_HUB_TABS.BRANDING;
  }
  return STORE_HUB_TABS.MAIN;
};
